type MatterportResponseType = {
  data: {
    model: { assets: { clips: { filename: string; url: string }[] } }
  }
}

export const getClips = async (modelId: string) => {
  try {
    const query = `query getClips($modelId: ID!) {
        model(id: $modelId) {
          assets {
            clips {
              filename
              url
            }
          }
        }
      }`

    const options = {
      body: JSON.stringify({
        query,
        variables: { modelId },
      }),
      headers: {
        'Content-Type': 'application/json',
      },
      method: 'post',
    } as const
    const url = import.meta.server
      ? 'https://api.matterport.com/api/mp/models/graph'
      : '/api/matterport-videos'
    return await $fetch<MatterportResponseType>(url, options)
  } catch {
    return {} as MatterportResponseType
  }
}

export const videoExist = async (url: string) => {
  const checkUrlAccessible = await fetch(url)

  return checkUrlAccessible.ok || false
}
